import styled from "styled-components";
import css from "@styled-system/css";
import { position, layout, PositionProps, LayoutProps } from "styled-system";

import Icon from "../Icon/Icon";
import { ReactNode, MouseEventHandler } from "react";

interface DropdownProps extends PositionProps, LayoutProps {
  children: ReactNode;
  close: MouseEventHandler<HTMLButtonElement>;
}

const StyledUl = styled.ul`
  ${css({
    backgroundColor: "primary-white",
    paddingX: [9, 6],
    paddingY: [9, 7],
    borderRadius: 2,
    fontSize: "body",
    fontFamily: "normal",
    width: ["100vw", "auto"],
  })}
  list-style: none;
  box-sizing: border-box;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  margin: 0;
  z-index: 10;
  ${position}
  ${layout}
`;

const CloseButton = styled.button`
  border: none;
  background: transparent;
  top: 27px;
  right: 27px;
  position: absolute;
  cursor: pointer;
  ${css({
    display: ["visible", "none"],
  })}
`;
export default function DropdownOptions({
  children,
  close,
  ...props
}: DropdownProps) {
  return (
    <StyledUl role="menu" {...props}>
      <CloseButton onClick={close}>
        <Icon name="times" weight="regular" width="16px" color="#3f403f" />
      </CloseButton>
      {children}
    </StyledUl>
  );
}
